import { Grid } from '@mui/material';
import React, { ChangeEvent } from 'react';
import NewCustomSelect from '../../../../newcustomselect/newcustomselect';
import { PartnerDetailsInterface } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import CustomTextField from '../../../../CustomTextInput';

const ConsigneeDetails = ({
    errors,
    payload,
    updateField,
    corporatePartners,
    setShowAddPartner,
    loadingCorporatepartners
}: PartnerDetailsInterface) => {
    return (
        <Grid container>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] pb-2 '>
                    <div className='lg:mt-4  '>
                        <NewCustomSelect
                            hasError={errors?.consigneeId.length > 0}
                            helperText={
                                errors?.consigneeId.length > 0
                                    ? errors?.consigneeId
                                    : undefined
                            }
                            selectValue={payload.consigneeId}
                            required
                            selectOptions={
                                corporatePartners as unknown as Record<
                                    string,
                                    unknown
                                >[]
                            }
                            name={'consigneeId'}
                            updateField={(_, value) => {
                                updateField('consigneeId', value);
                                updateField(
                                    'consigneeAddress',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.address
                                );
                                updateField(
                                    'consigneeName',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.name
                                );
                                updateField(
                                    'consigneeBankName',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.bankName
                                );
                                updateField(
                                    'consigneeAccountNumber',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.bankAccountNumber
                                );
                                updateField(
                                    'consigneeCountry',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.bankCountry
                                );
                                updateField(
                                    'consigneeSwiftCode',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.swiftCode
                                );
                            }}
                            label={'Consignee'}
                            selectOptionLabel='name'
                            loading={loadingCorporatepartners}
                            dropdownRender={() => {
                                return (
                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                        <p
                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                            onClick={() => {
                                                setShowAddPartner(true);
                                            }}
                                        >
                                            + Add a New Partner
                                        </p>
                                    </div>
                                );
                            }}
                        />
                    </div>
                    <div className=' lg:mt-4 mt-2'>
                        <CustomTextField
                            error={errors?.consigneeAddress.length > 0}
                            helperText={
                                errors?.consigneeAddress.length > 0
                                    ? errors?.consigneeAddress
                                    : undefined
                            }
                            value={payload?.consigneeAddress}
                            required
                            id='quotation-documentName'
                            label='Consignee Address'
                            name='consigneeAddress'
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                updateField('consigneeAddress', e.target.value);
                            }}
                        />
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] pb-2'>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4 '>
                                <CustomTextField
                                    error={
                                        errors?.billOfLadingNumber.length > 0
                                    }
                                    helperText={
                                        errors?.billOfLadingNumber.length > 0
                                            ? errors?.billOfLadingNumber
                                            : undefined
                                    }
                                    value={payload?.billOfLadingNumber || ''}
                                    required
                                    id='proformainvoice-billOfLadingNumber'
                                    label='Bill of Lading Number'
                                    name='billOfLadingNumber'
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'billOfLadingNumber',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4 mt-2'>
                                <CustomTextField
                                    error={
                                        errors?.salesContractNumber.length > 0
                                    }
                                    helperText={
                                        errors?.salesContractNumber.length > 0
                                            ? errors?.salesContractNumber
                                            : undefined
                                    }
                                    value={payload?.salesContractNumber || ''}
                                    required
                                    id='proformainvoice-salesContractNumber'
                                    label='Sales Contract Number'
                                    name='salesContractNumber'
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'salesContractNumber',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={12}>
                            <div className='lg:mt-4 mt-2'>
                                <CustomTextField
                                    error={errors?.buyerReference.length > 0}
                                    helperText={
                                        errors?.buyerReference.length > 0
                                            ? errors?.buyerReference
                                            : undefined
                                    }
                                    required
                                    id='commercialinvoice-buyerReference'
                                    label='Buyer Reference'
                                    name='buyerReference'
                                    value={payload?.buyerReference || ''}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'buyerReference',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>

                    <div className='lg:mt-4 mt-2'>
                        <NewCustomSelect
                            hasError={errors?.buyerId.length > 0}
                            helperText={
                                errors?.buyerId.length > 0
                                    ? errors?.buyerId
                                    : undefined
                            }
                            selectValue={payload.buyerId}
                            selectOptions={
                                corporatePartners as unknown as Record<
                                    string,
                                    unknown
                                >[]
                            }
                            name={'buyerId'}
                            updateField={(_, value) => {
                                updateField('buyerId', value);
                                updateField(
                                    'buyerAddress',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.address
                                );
                                updateField(
                                    'buyer',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.name
                                );
                            }}
                            label={'Buyer (if not Consignee)'}
                            selectOptionLabel='name'
                            loading={loadingCorporatepartners}
                            dropdownRender={() => {
                                return (
                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                        <p
                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                            onClick={() => {
                                                setShowAddPartner(true);
                                            }}
                                        >
                                            + Add a New Partner
                                        </p>
                                    </div>
                                );
                            }}
                        />
                    </div>

                    <div className='lg:mt-4 lg:mb-2 mt-2'>
                        <CustomTextField
                            error={errors?.buyerAddress.length > 0}
                            helperText={
                                errors?.buyerAddress.length > 0
                                    ? errors?.buyerAddress
                                    : undefined
                            }
                            value={payload?.buyerAddress || ''}
                            id='quotation-buyerAddress'
                            label='Buyer Address (if not Consignee)'
                            name='buyerAddress'
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                updateField('buyerAddress', e.target.value);
                            }}
                        />
                    </div>
                </div>
            </Grid>
        </Grid>
    );
};

export default ConsigneeDetails;
